<div class="container">
  <div class="section-left">
    <!-- Step 1: Enter Username -->
    <form
      *ngIf="step === 'email'"
      [formGroup]="forgotPasswordForm"
      (ngSubmit)="sendResetCode()"
    >
      <div class="logo">
        <img src="assets/images/logo.png" alt="logo" i18n-alt="Logo alt text@@logoAlt" />
      </div>
      <h1>HERO</h1>
      <p i18n="Reset password tagline@@resetPasswordTagline">Reset your <strong>password</strong></p>

      <app-input
        leftIcon="ri-user-fill"
        i18n-placeholder="Email placeholder@@emailPlaceholder"
        placeholder="Email"
        formControlName="username"
      />

      <button
        pButton
        type="submit"
        class="p-button-block"
        i18n-label="Send reset code button@@sendResetCodeButton"
        label="Send Reset Code"
        [loading]="isLoading"
        [disabled]="forgotPasswordForm.invalid || isLoading"
      ></button>

      <button
        pButton
        type="button"
        class="p-button-block p-button-secondary back-button"
        i18n-label="Back to login button@@backToLoginButton"
        label="Back to Login"
        (click)="goBack()"
      ></button>
    </form>

    <!-- Step 2: Enter Reset Code and New Password -->
    <form
      *ngIf="step === 'reset-code'"
      [formGroup]="resetCodeForm"
      (ngSubmit)="submitNewPassword()"
    >
      <div class="logo">
        <img src="assets/images/logo.png" alt="logo" i18n-alt="Logo alt text@@logoAlt" />
      </div>
      <h1>HERO</h1>
      <p i18n="Enter code tagline@@enterCodeTagline">Enter the code from your <strong>email</strong></p>

      <app-input
        leftIcon="ri-mail-line"
        i18n-placeholder="Reset code placeholder@@resetCodePlaceholder"
        placeholder="Reset Code"
        formControlName="confirmationCode"
      />

      <app-input
        leftIcon="ri-lock-fill"
        i18n-placeholder="New password placeholder@@newPasswordPlaceholder"
        placeholder="New Password"
        formControlName="newPassword"
        type="password"
      />

      <app-password-requirements [password]="newPassword" />

      <app-input
        leftIcon="ri-lock-fill"
        i18n-placeholder="Confirm password placeholder@@confirmPasswordPlaceholder"
        placeholder="Confirm Password"
        formControlName="confirmPassword"
        type="password"
      />

      <button
        pButton
        type="submit"
        class="p-button-block"
        i18n-label="Update password button@@updatePasswordButton"
        label="Update Password"
        [loading]="isLoading"
        [disabled]="resetCodeForm.invalid || isLoading"
      ></button>

      <button
        pButton
        type="button"
        class="p-button-block p-button-secondary back-button"
        i18n-label="Back button@@backButton"
        label="Back"
        (click)="goBack()"
      ></button>
    </form>
  </div>
  <div class="section-right"></div>

  <p-toast
    position="bottom-center"
    [showTransformOptions]="'translateY(100%) scale(1)'"
    [showTransitionOptions]="'0.3s cubic-bezier(0.68, -0.55, 0.27, 1.55)'"
  />
</div>